import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { queryKeys } from '~/routes/app-paths';

import { TabsType } from '../utils';
import * as S from './EventTabs.styles';

export interface EventTabsProps {
  activeTab: TabsType;
}

export const EventTabs = ({ activeTab }: EventTabsProps) => {
  const { t } = useTranslation(['calendar']);
  const [, setSearchParams] = useSearchParams();

  const TABS = useMemo(
    () => [
      {
        tabKey: TabsType.Earnings,
        tabLabel: t('calendar:earnings'),
      },
      {
        tabKey: TabsType.Economics,
        tabLabel: t('calendar:economic'),
      },
      {
        tabKey: TabsType.Company,
        tabLabel: t('calendar:company'),
      },
    ],
    []
  );

  const onChange = (_: number, tabKey: string) => {
    if (tabKey !== activeTab) {
      setSearchParams(params => {
        params.set(queryKeys.activeCalendarTab, tabKey);
        return params;
      });
    }
  };

  return (
    <S.StyledTabLines tabs={TABS} activeTab={activeTab} onChange={onChange} />
  );
};
